module.exports = new __parcel__URL__("staffing-preview-dark.a8fbe72d.svg").toString();